import { SIZE_GUIDE_IDENTIFIER } from '@bluheadless/ui-logic/src/constants'
import { useCmsBlock } from '@bluheadless/ui-logic/src/hooks/cms/useCmsBlock'
import { useConfig } from '@bluheadless/ui-logic/src/providers/config'
import { useProductContext } from '@bluheadless/ui-logic/src/providers/product'
import { cx } from '@emotion/css'
import { shape, string } from 'prop-types'
import { useCallback, useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import Price from '../../molecules/price/price'
import Block from '../../particles/cms-block/block'
import { SizeGuideContent, SizeGuideLink, SwipeableDrawerStyled, ButtonClose } from './size-guide.styled'
import XIcon from '../../atoms/icons/x-icon'

const SizeGuide = ({ className }) => {
	const [dialogOpen, setDialogOpen] = useState(false)
	const { formatMessage } = useIntl()

	const {
		catalog: {
			products: {
				attributesMapping: { sizeGuide },
			},
		},
	} = useConfig()

	const productContextValue = useProductContext()

	const [{ product: { attributes } = {} }] = productContextValue

	const generateCmsBlockIdentifier = useCallback(() => {
		let identifier = SIZE_GUIDE_IDENTIFIER
		sizeGuide.forEach((attributeCode) => {
			if (attributes[attributeCode] && attributes[attributeCode]?.value) {
				identifier = identifier.concat('-' + attributeCode + '-' + attributes[attributeCode].value)
			}
		})
		return identifier
	}, [attributes, sizeGuide])

	const { content: cmsBlockContent } = useCmsBlock({ identifier: generateCmsBlockIdentifier() })

	return cmsBlockContent?.length > 0 ? (
		<>
			<SizeGuideLink onClick={() => setDialogOpen(true)} variant="caption">
				<FormattedMessage id={'size_guide_cta_label'} />
			</SizeGuideLink>

			<SwipeableDrawerStyled
				className={cx('SizeGuide-root', className)}
				anchor="right"
				onClose={() => setDialogOpen(false)}
				open={dialogOpen}
				disableSwipeToOpen
				PaperProps={{
					className: 'sizeguide',
				}}
			>
				<SizeGuideContent>
					<ButtonClose
						Icon={XIcon}
						onClick={() => setDialogOpen(false)}
						variant="icon"
						label={formatMessage({ id: 'close' })}
					/>
					<Block content={cmsBlockContent} />
				</SizeGuideContent>
			</SwipeableDrawerStyled>
		</>
	) : null
}

SizeGuide.propTypes = {
	/**
	 * Product name
	 */
	name: string,
	/**
	 * Price props
	 */
	priceProps: shape(Price.propTypes),
	/**
	 * Table subtitle
	 */
	subtitle: string,
	/**
	 * Title title
	 */
	title: string,
}

export default SizeGuide
